import React from 'react'

type Props = {
    className?: string
}

export const ZoomOutIcon = (props: Props) => {
    const { className = 'w-5 h-5' } = props

    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" x2="16.65" y1="21" y2="16.65"/>
            <line x1="8" x2="14" y1="11" y2="11"/>
        </svg>
    )
}
